import React from 'react';
import { Box, Typography } from '@mui/material';

function LinearRegressionExample() {
  return (
    <Box>
      <Typography variant="h6">Linear Regression Example</Typography>
      <Typography>
        This is a placeholder for the linear regression example.
      </Typography>
    </Box>
  );
}

export default LinearRegressionExample;
